import React, { useState, useRef, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  Tag,
  Wallet,
  Puzzle,
  ArrowLeftRight,
  CircleHelp,
  ExternalLink,
  Store,
  ChevronDown,
  ChevronUp,
  Plus,
} from "lucide-react";

import { useOutlets } from "../hooks/useOutlets";

// import "./Sidebar.css";

export function Sidebar() {
  const navigate = useNavigate();

  const [showOutletMenu, setShowOutletMenu] = useState(false);

  const outletMenuRef = useRef(null);

  const selectedOutletUid =
    localStorage.getItem("selectedOutletUid");


  // Handle click outside of the outlet menu to close it
  useEffect(() => {

    function handleClickOutside(event) {

      if (
        outletMenuRef.current &&
        !outletMenuRef.current.contains(event.target)
      ) {

        setShowOutletMenu(false);

      }

    }

    document.addEventListener(
      "mousedown",
      handleClickOutside
    );

    return () =>

      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );

  }, []);

  const navItems = [
    {
      title: "Overview",
      icon: LayoutDashboard,
      path: "/overview",
    },
    {
      title: "Offers",
      icon: Tag,
      path: "/offers",
    },
    {
      title: "Wallet",
      icon: Wallet,
      path: "/wallet",
    },
    {
      title: "Transactions",
      icon: ArrowLeftRight,
      path: "/transactions",
    },
    {
      title: "Integrations",
      icon: Puzzle,
      path: "/integrations",
    }
  ];

  const {

    data,

    isLoading,

    error,

  } = useOutlets();

  // const selectedOutletUid =
  //   localStorage.getItem(
  //     "selectedOutletUid"
  //   );

  return (
    <aside className="sidebar">

      <div>

        {/* Logo */}

        <div className="sidebar-logo">

          <img
            src={require("./../imgs/nextgo-logo.png")}
            alt="Next Go Logo"
            className="sidebar-logo-icon"
          />

          <span className="sidebar-logo-text">
            Next<span className="blue">Go</span>
          </span>

        </div>

        {/* Outlet Selector */}

        {!isLoading && !error && (

          <div
            className="outlet-dropdown"
            ref={outletMenuRef}
          >

            <button

              className="outlet-dropdown-button"

              onClick={() =>

                setShowOutletMenu(

                  !showOutletMenu

                )

              }

            >

              <div className="outlet-dropdown-left">

                <Store size={18} />

                <span>

                  {
                    data.outlets.find(

                      outlet =>

                        outlet.outletUid === selectedOutletUid

                    )?.outletName || "Select Outlet"
                  }

                </span>

              </div>

              {showOutletMenu ? (
                <ChevronUp size={18} />
              ) : (
                <ChevronDown size={18} />
              )}

            </button>

            {

              showOutletMenu && (

                <div className="outlet-dropdown-menu">

                  {

                    data.outlets.map((outlet) => (

                      <button

                        key={outlet.outletUid}

                        className={`outlet-item ${outlet.outletUid === selectedOutletUid
                            ? "active"
                            : ""
                          }`}

                        onClick={() => {

                          localStorage.setItem(

                            "selectedOutletUid",

                            outlet.outletUid

                          );

                          window.location.reload();

                        }}

                      >

                        {outlet.outletName}

                      </button>

                    ))

                  }

                  <div className="outlet-divider" />

                  <button

                    className="add-outlet-item"

                    onClick={() =>

                      navigate("/add-outlet")

                    }

                  >

                    <Plus size={16} />

                    Add New Outlet

                  </button>

                </div>

              )

            }

          </div>

        )}

        {/* Navigation */}

        <nav className="sidebar-nav">

          {navItems.map((item) => {

            const Icon = item.icon;

            return (

              <NavLink
                key={item.title}
                to={item.path}
                end={item.path === "/"}
                className={({ isActive }) =>
                  isActive
                    ? "sidebar-link active"
                    : "sidebar-link"
                }
              >

                <Icon size={20} />

                <span>{item.title}</span>

              </NavLink>

            );

          })}

        </nav>

      </div>

      {/* Bottom */}

      <div className="sidebar-bottom">

        {/* <button className="getting-started-card">

          <Rocket size={24} />

          <div>

            <strong>Need help getting started?</strong>

            <p>See our quick start guide</p>

          </div>

          <ChevronRight size={18} />

        </button> */}

        <button className="support-button">

          <CircleHelp size={20} />

          <span>Help & Support</span>

          <ExternalLink size={16} />

        </button>

      </div>

    </aside>
  );
}